import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    INDEX_PAYMENT_REPORT_REPORT,
    INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS,
    INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF,
    INDEX_PAYMENT_REPORT_DESTINATION,
} from '../../actions';

import {
    IndexPaymentReportReportSuccess,
    IndexPaymentReportReportError,
    IndexPaymentReportRegularizationIGSSSuccess,
    IndexPaymentReportRegularizationIGSSError,
    IndexPaymentReportRegularizationIGSSPDFSuccess,
    IndexPaymentReportRegularizationIGSSPDFError,
    IndexPaymentReportDestinationSuccess,
    IndexPaymentReportDestinationError,
} from '../../actions';

export function* watchIndexPaymentReportReport() {
    yield takeEvery(INDEX_PAYMENT_REPORT_REPORT, onIndexPaymentReportReport);
}

export function* watchIndexPaymentReportRegularizationIGSS() {
    yield takeEvery(INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS, onIndexPaymentReportRegularizationIGSS);
}

export function* watchIndexPaymentReportRegularizationIGSSPDF() {
    yield takeEvery(INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF, onIndexPaymentReportRegularizationIGSSPDF);
}

export function* watchIndexPaymentReportDestination() {
    yield takeEvery(INDEX_PAYMENT_REPORT_DESTINATION, onIndexPaymentReportDestination);
}
function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onIndexPaymentReportReportAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'idxPaymentReport/listreport', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onIndexPaymentReportRegularizationIGSSAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'idxPaymentReport/regularizationIGSS', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onIndexPaymentReportRegularizationIGSSPDFAsync = async (payload) => {

    let token = await getToken(authFB);

    const response = await fetch(
        servicePath + 'idxPaymentReport/regularizationIGSSPDF',
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'token': token
            },
            body: JSON.stringify(payload)
        }
    );

    if (!response.ok) {
        throw new Error("Error generating PDF");
    }

    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "InformeGastosIGSS.pdf";

    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);

    return true;
};


const onIndexPaymentReportDestinationAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'idxPaymentReport/destination', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

function* onIndexPaymentReportReport(data) {
    try {
        const response = yield call(onIndexPaymentReportReportAsync, data.payload);
        yield put(IndexPaymentReportReportSuccess(response.data));
    } catch (error) {
        yield put(IndexPaymentReportReportError(error));
    }
}

function* onIndexPaymentReportRegularizationIGSS(data) {
    try {
        const response = yield call(onIndexPaymentReportRegularizationIGSSAsync, data.payload);
        yield put(IndexPaymentReportRegularizationIGSSSuccess(response.data));
    } catch (error) {
        yield put(IndexPaymentReportRegularizationIGSSError(error));
    }
}

function* onIndexPaymentReportRegularizationIGSSPDF(action) {
    try {
        yield call(
            onIndexPaymentReportRegularizationIGSSPDFAsync,
            action.payload
        );

        yield put(
            IndexPaymentReportRegularizationIGSSPDFSuccess()
        );

    } catch (error) {

        yield put(
            IndexPaymentReportRegularizationIGSSPDFError(error)
        );

    }
}

function* onIndexPaymentReportDestination(data) {
    try {
        const response = yield call(onIndexPaymentReportDestinationAsync, data.payload);
        yield put(IndexPaymentReportDestinationSuccess(response.data));
    } catch (error) {
        yield put(IndexPaymentReportDestinationError(error));
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchIndexPaymentReportReport),
        fork(watchIndexPaymentReportRegularizationIGSS),
        fork(watchIndexPaymentReportRegularizationIGSSPDF),
        fork(watchIndexPaymentReportDestination),
    ]);
}